import React from 'react';
import styled from 'styled-components';
import {IconoirEditPencil, IconoirTrash} from '@ey-xd/motif-icon';

import Utility from '../../../../../../../../util/utilityfunctions';
import {labels} from '../../../../../../../../util/utils';
import {attributeTestingTypes} from '../../../../../../../../util/uiconstants';
import Button from '../../../../../../BaseComponentWrappers/MotifButton';
import Checkbox from '../../../../../../BaseComponentWrappers/MotifCheckbox';

export default function AttributesListItem(props) {
	const {
		attributeDescription,
		attributeIndex,
		testingTypes,
		attributeId,
		handleOnEditAttribute,
		handleOnDeteleAttribute
	} = props;

	const onEditAttribute = () => handleOnEditAttribute(attributeId);
	const onDeleteAttribute = () => handleOnDeteleAttribute(attributeId);

	return (
		<Wrapper className="AttributesListItem">
			<AttributeContent>
				<AttributeIndex>{attributeIndex}</AttributeIndex>
				<AttributeDescription>{Utility.createRichTextElement(attributeDescription)}</AttributeDescription>
				<ActionButtons>
					<Button
						ariaLabel={`${labels.editAttributeButtonLabel}`}
						iconTitle={`${labels.editAttributeButtonLabel}`}
						className="motif-button-icon-only"
						type="button"
						variant="ghost"
						size="medium"
						showIcon
						iconFunction={IconoirEditPencil}
						onClick={onEditAttribute}
					/>

					<Button
						ariaLabel={`${labels.deleteAttributeButtonLabel}`}
						iconTitle={`${labels.deleteAttributeButtonLabel}`}
						className="motif-button-icon-only"
						type="button"
						variant="ghost"
						size="medium"
						showIcon
						iconFunction={IconoirTrash}
						onClick={onDeleteAttribute}
					/>
				</ActionButtons>
			</AttributeContent>
			<AttributeProcedures>
				<h5>{labels.proceduresLabel}</h5>
				<CheckboxWrapper>
					{Object.entries(attributeTestingTypes).map(([id, value]) => {
						const isChecked = testingTypes?.includes(value);

						return (
							<Checkbox
								key={`${attributeId}-${id}`}
								id={`${attributeId}-${id}`}
								checked={isChecked}
								label={labels.attributeTestingTypesLabel[id]}
								disabled
							/>
						);
					})}
				</CheckboxWrapper>
			</AttributeProcedures>
		</Wrapper>
	);
}

const Wrapper = styled.section`
	display: flex;
	flex-direction: column;
	padding: var(--px-16) var(--px-24);
	gap: var(--px-24);
`;

const AttributeContent = styled.section`
	display: flex;
	gap: var(--px-12);
`;

const AttributeIndex = styled.h4`
	font-size: var(--px-16);
	line-height: var(--px-20);
	font-weight: 400;
	color: var(--neutrals-900);
	width: var(--px-80);
	margin: var(--px-8) 0 0 0;
`;

const AttributeDescription = styled.section`
	flex: 2;
	overflow: hidden;
	font-size: var(--px-14);
	font-weight: 300;
	line-height: var(--px-20);
	color: var(--neutrals-900);
	margin: var(--px-8) 0 0 0;

	.createRichTextElementSpanWrapper {
		ul,
		ol {
			padding-left: var(--px-40);
			margin-top: var(--px-14);
			margin-bottom: var(--px-14);
		}

		li {
			margin-bottom: 0;

			p {
				margin: 0;
			}
		}

		p {
			margin: 0;
		}
	}
`;

const ActionButtons = styled.section`
	display: flex;
`;

const AttributeProcedures = styled.section`
	h5 {
		font-size: var(--px-14);
		line-height: var(--px-20);
		font-weight: 400;
		color: var(--neutrals-900);
		margin: 0;
	}
`;

const CheckboxWrapper = styled.section`
	display: flex;

	> span {
		padding: var(--px-10) 0;
		flex-grow: 1;
		text-align: center;

		.motif-checkbox-label {
			font-size: var(--px-14);
		}

		.motif-checkbox-disabled {
			cursor: default;
		}

		.motif-checkbox-disabled .motif-checkbox-input[checked]:not([checked='false']) + .motif-checkbox-inner {
			background-color: var(--ui-stroke-disabled);
			border-color: var(--ui-stroke-disabled);

			& .motif-checkbox-icon {
				color: var(--ui-background-main);
			}
		}
	}
`;
